import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Modal from '~/Common-Objects/Modal/index'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import postHogFunctions from '~/Classes/posthog'
import AutomationThemeCard from '~/Common-Objects/Automations/automationThemeCard'
import * as styles from './index.module.scss'

const CreateAutomationModal = ({ onClose }) => {
    const [loaded, setLoaded] = useState(false)
    const [themes, setThemes] = useState([])
    const [saving, setSaving] = useState(false)
    const history = useHistory()

    useEffect(() => {
        axios
            .get('/automation/themes')
            .then((response) => setThemes(response.data.Themes))
            .then(() => setLoaded(true))
            .catch((err) => console.log(err))
    }, [])

    const handleClick = async (themeType, theme) => {
        if (saving) return
        if (themeType === 'theme') {
            setSaving(theme.id)
            postHogFunctions.capture('automation_created_theme')
            const response = await axios.post('/automation/theme/' + theme.id)
            history.push('/cp/automation/addnew/' + response.data.Automation.id)
        } else {
            postHogFunctions.capture('automation_created_scratch')
            history.push('/cp/automation/addnew')
        }
        onClose()
    }

    return (
        <Modal
            width='90%'
            height='90%'
            noClickAway={true}
            top={false}
            blurBg={true}
            closeButton={true}
            onCloseButton={onClose}
        >
            <h2 className={styles.modalTitle}>{i18n.t('automation:add.header')}</h2>
            <div className={styles.modalContent}>
                {loaded ? (
                    <div className={styles.themeCards}>
                        <AutomationThemeCard type={'scratch'} saving={saving === 'scratch'} onClick={handleClick} />
                        {themes.map((theme) => (
                            <AutomationThemeCard
                                key={theme.id}
                                saving={saving === theme.id}
                                theme={theme}
                                onClick={handleClick}
                            />
                        ))}
                    </div>
                ) : (
                    <LoadingIcons iconType='2' />
                )}
            </div>
        </Modal>
    )
}

export default CreateAutomationModal
